import React from "react";
import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from "recharts";
import {
  ChartConfig,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";

interface AreaChartComponentProps {
  data: any[];
  config: ChartConfig;
}

export const AreaChartComponent: React.FC<AreaChartComponentProps> = ({
  data,
  config,
}) => {
  return (
    <AreaChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
      <defs>
        {Object.keys(config).map((key) => (
          <linearGradient
            key={key}
            id={`fill${key}`}
            x1="0"
            y1="0"
            x2="0"
            y2="1"
          >
            <stop offset="5%" stopColor={config[key].color} stopOpacity={0.8} />
            <stop
              offset="95%"
              stopColor={config[key].color}
              stopOpacity={0.1}
            />
          </linearGradient>
        ))}
      </defs>
      <CartesianGrid
        vertical={false}
        className="stroke-border dark:stroke-gray-600"
      />
      <YAxis
        tickLine={false}
        axisLine={false}
        width={40}
        className="text-text-tertiary dark:text-gray-400"
        allowDecimals={false}
        tickFormatter={(value: number) =>
          value >= 1000 ? `${Math.round(value / 1000)}k` : `${value}`
        }
      />
      <XAxis
        dataKey="date"
        tickLine={false}
        axisLine={false}
        tickMargin={8}
        minTickGap={32}
        className="text-text-tertiary dark:text-gray-400"
        tickFormatter={(value) => {
          const date = new Date(value);
          return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          });
        }}
      />
      <ChartTooltip
        cursor={false}
        content={
          <ChartTooltipContent
            labelFormatter={(value) => {
              return new Date(value).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              });
            }}
            indicator="dot"
          />
        }
      />
      {Object.keys(config).map((key) => (
        <Area
          key={key}
          dataKey={key}
          type="natural"
          fill={`url(#fill${key})`}
          stroke={config[key].color}
          stackId="a"
        />
      ))}
      <ChartLegend content={<ChartLegendContent payload={[]} />} />
    </AreaChart>
  );
};
